import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useRef, useState } from 'react';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
// import ReactDOMServer from 'react-dom/server';
import { Propertybookings } from '../../Services/Service';

export const TodayBookingReport = () => {
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [filterDate, setFilterDate] = useState("");
    const reportRef = useRef(null);


    const fetchBookings = async (params = {}) => {
        setLoading(true);
        try {
            const data = await Propertybookings(params);
            // setBookingData(data || []);
            setBookingData((data || []).reverse());
        } catch (error) {
            console.log("Error fetching bookings", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Set today's date in YYYY-MM-DD and auto-fetch bookings for today
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formatted = `${yyyy}-${mm}-${dd}`;

        setFilterDate(formatted);
        // Fetch bookings filtered by today's date
        fetchBookings({ BookingDate: formatted });
    }, []);

    const handleFilter = () => {
        if (!filterDate) {
            alert("Please select a date");
            return;
        }

        fetchBookings({ BookingDate: filterDate });
    };

    const exportPdf = async () => {
        setLoading(true);
        if (!reportRef.current) return;
        try {
            // dynamic import to avoid SSR issues
            const html2pdf = (await import('html2pdf.js')).default;

            const opt = {
                margin: 0.4,                          // inches
                filename: `Today_Booking_Report_${filterDate || 'all'}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true, logging: false },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
            };

            // pass the element you want to convert
            html2pdf().set(opt).from(reportRef.current).save();
        } catch (err) {
            console.error("PDF export failed", err);
            alert("PDF export failed, check console for details.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <style>{`
         
        tr th{
           font-size: 12px !important;
        }
           label{
             font-weight:bold !important;
           }

           .booking-filter-form .card-body .d-flex > div {
            flex: 0 0 auto;
            max-width: none;
          }

      @media (max-width: 768px) {
        .booking-filter-form .card-body .d-flex {
          flex-wrap: wrap;
          gap: 0.75rem;
          align-items: flex-start;
        }

  .booking-filter-form .card-body .d-flex > div {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .booking-filter-form .card-body .d-flex > div .btn {
    min-width: 110px;    
  }

  @media (max-width: 420px) {
    .booking-filter-form .card-body .d-flex > div:last-child {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .booking-filter-form .card-body .d-flex > div:last-child .btn {
      width: 100%;
      min-width: unset;
    }
  }

  .booking-filter-form .card-body .form-label {
    font-size: 0.92rem;
  }
}

.booking-filter-form .card-body .form-control {
  box-sizing: border-box;
  width: 100%;
}
    `}</style>

            {loading && (
                <FullScreenLoader />
            )}

            <div className="wrapper ">
                <SideBar />
                <div className="main-panel">
                    <Hearder />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <form>
                                        <div className='d-flex gap-3' style={{ placeContent: "flex-end" }}>
                                            <div>
                                                <input
                                                    className='form-control'
                                                    type='date'
                                                    value={filterDate}
                                                    onChange={(e) => setFilterDate(e.target.value)}
                                                />
                                            </div>

                                            <div className='text-end mb-3'>
                                                <button
                                                    className='btn btn-primary me-2'
                                                    type='button'
                                                    onClick={handleFilter}
                                                >
                                                    Filter
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-item-center'>
                                                <h4 className="card-title">Today booking report</h4>
                                                <button className='btn btn-sm btn-primary' type="button"
                                                    onClick={exportPdf}>Export</button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div ref={reportRef} style={{ padding: 16, background: '#fff' }}>
                                                    <table className="display table  table-bordered table-striped table-hover basic-datatables">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "45px" }}>Sr#</th>
                                                                <th style={{ width: "110px" }} >BON REF. Id</th>
                                                                <th style={{ width: "110px" }}>Conf. No</th>
                                                                <th style={{ width: "95px" }}>Check-in</th>
                                                                <th style={{ width: "110px" }}>Check-out</th>
                                                                <th >Guest Info</th>
                                                                <th style={{ width: "81px" }}>Payment </th>
                                                                <th style={{ width: "81px" }}>Status</th>
                                                                <th style={{ width: "95px" }}>Book On</th>

                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {bookingData.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="9" className="text-center py-3 text-muted">
                                                                        No Booking Found
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                bookingData.map((item) => (
                                                                    <tr key={item.ID}>
                                                                        <td>{item.SrNo}</td>
                                                                        <td>{item.BONRESID}</td>
                                                                        <td>{item.PMSRESID}</td>
                                                                        <td>{item.CheckInDate}</td>
                                                                        <td>{item.CheckOutDate}</td>
                                                                        <td>
                                                                            <b>{item.GuestName}</b>
                                                                            <div>{item.CompanyName}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div> ₹ {item.TotalPayment}</div>
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        item.PaymentStatus === "Paid"
                                                                                            ? "text-success"
                                                                                            : item.PaymentStatus === "Pending"
                                                                                                ? "text-warning"
                                                                                                : "text-secondary"
                                                                                    }
                                                                                >
                                                                                    {item.PaymentStatus || "N/A"}
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-center">
                                                                            <span
                                                                                className={
                                                                                    item.BookingStatus === "Confirmed"
                                                                                        ? "text-success"
                                                                                        : item.BookingStatus === "Pending"
                                                                                            ? "text-warning"
                                                                                            : item.BookingStatus === "Cancelled"
                                                                                                ? "text-danger"
                                                                                                : "text-secondary"
                                                                                }
                                                                            >
                                                                                {item.BookingStatus || "N/A"}
                                                                            </span>
                                                                        </td>

                                                                        <td>{item.BookingDate}</td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>

            </div>

        </>
    )
}
